import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { AbstractVisual } from "./AbstractVisual";
import { api } from "../lib/api";

export const PartnersSection = () => {
  const [partners, setPartners] = useState([]);
  useEffect(() => {
    api.list("partners")
      .then((d) => setPartners(d.slice().sort((a, b) => (a.order ?? 99) - (b.order ?? 99))))
      .catch(() => {});
  }, []);
  if (!partners.length) return null;
  return (
    <section data-testid="partners-section" className="py-28 md:py-40 border-t border-white/[0.06]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <SectionHeading overline="Our Partners" title={<>In Partnership <span className="italic text-zinc-400">With the Best.</span></>} />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
          {partners.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <a href={p.url} target="_blank" rel="noreferrer" data-testid={`partner-card-${p.slug}`}
                className="group relative block overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-8 md:p-10 h-full poster-sheen hover:border-white/30 hover:-translate-y-1.5 transition-all duration-500">
                <AbstractVisual hue={p.hue ?? 222} seed={(p.hue ?? 222) + 3} className="opacity-25 group-hover:opacity-50 transition-opacity duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030305]/80 via-transparent to-transparent" />
                <div className="relative">
                  {p.logo && (
                    <div className="inline-flex items-center justify-center bg-white rounded-xl px-4 py-3 mb-7 h-20" data-testid={`partner-logo-${p.slug}`}>
                      <img src={p.logo} alt={`${p.name} logo`} className="h-full w-auto object-contain" />
                    </div>
                  )}
                  <p className="text-[11px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-6">{p.type}</p>
                  <h3 className="font-serif text-3xl md:text-4xl tracking-tight mb-5">{p.name}</h3>
                  <p className="text-zinc-400 font-light leading-relaxed mb-10 text-sm md:text-base">{p.tagline}</p>
                  <span className="inline-flex items-center gap-2 text-sm text-zinc-300 group-hover:text-white transition-colors">
                    {p.url.replace("https://", "").replace(/\/$/, "")}
                    <ArrowUpRight size={15} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
